
  //  const featuredProducts = {
  //       all: [
  //         ['RADIANT SOLITAIRE RING', '$89', '$120', 'https://www.figma.com/api/mcp/asset/668f9ac4-778e-4131-a484-0944085db60e.png'],
  //         ['HOLY WATER PENDANT', '$99', '$129', 'https://www.figma.com/api/mcp/asset/cf7990eb-5926-446a-a8b2-4844c87672f3.png'],
  //         ['ETERNITY GOLD BAND', '$79', '$99', 'https://www.figma.com/api/mcp/asset/a359ba75-947a-4611-b6e7-02d38c568611.png'],
  //         ['RADIANT FAITH NECKLACE', '$89', '$115', 'https://www.figma.com/api/mcp/asset/2c1c079f-bffd-4584-88e0-89a8d6760985.png']
  //       ],
  //       necklaces: [['RADIANT FAITH NECKLACE', '$89', '$115', 'https://www.figma.com/api/mcp/asset/2c1c079f-bffd-4584-88e0-89a8d6760985.png'], ['HOLY WATER PENDANT', '$99', '$129', 'https://www.figma.com/api/mcp/asset/cf7990eb-5926-446a-a8b2-4844c87672f3.png']],
  //       rings: [['RADIANT SOLITAIRE RING', '$89', '$120', 'https://www.figma.com/api/mcp/asset/668f9ac4-778e-4131-a484-0944085db60e.png'], ['ETERNITY GOLD BAND', '$79', '$99', 'https://www.figma.com/api/mcp/asset/a359ba75-947a-4611-b6e7-02d38c568611.png']],
  //       bracelets: [['ETERNITY GOLD BAND', '$79', '$99', 'https://www.figma.com/api/mcp/asset/a359ba75-947a-4611-b6e7-02d38c568611.png']],
  //       earrings: [['RADIANT SOLITAIRE RING', '$89', '$120', 'https://www.figma.com/api/mcp/asset/668f9ac4-778e-4131-a484-0944085db60e.png']],
  //       mens: [['ETERNITY GOLD BAND', '$79', '$99', 'https://www.figma.com/api/mcp/asset/a359ba75-947a-4611-b6e7-02d38c568611.png']],
  //       womens: [['RADIANT SOLITAIRE RING', '$89', '$120', 'https://www.figma.com/api/mcp/asset/668f9ac4-778e-4131-a484-0944085db60e.png'], ['RADIANT FAITH NECKLACE', '$89', '$115', 'https://www.figma.com/api/mcp/asset/2c1c079f-bffd-4584-88e0-89a8d6760985.png']]
  //     };
  //     const SWATCHES = 'https://www.figma.com/api/mcp/asset/d0ff4968-e3d4-42aa-8047-f0bcfe382b42.svg';
  //     const productGrid = document.querySelector('.aneezay-product-grid--featured');
  //     const tabs = Array.from(document.querySelectorAll('.aneezay-featured__tabs button'));
  //     const productCard = ([name, price, oldPrice, image]) =>
  //       `<article class="aneezay-product-card"><a href="#" class="aneezay-product-card__image"><img src="${image}" alt="${name}" loading="lazy"></a><h3>${name}</h3><div class="aneezay-product-card__price"><strong>${price}</strong><del>${oldPrice}</del></div><img class="aneezay-product-card__swatches" src="${SWATCHES}" alt="Available colors"  loading="lazy" decoding="async" /><button class="aneezay-button aneezay-button--product" type="button">ADD TO CART</button></article>`;

  //     function activateTab(tab) {
  //       tabs.forEach((item) => {
  //         item.classList.remove('is-active');
  //         item.setAttribute('aria-selected', 'false');
  //         item.setAttribute('tabindex', '-1');
  //       });
  //       tab.classList.add('is-active');
  //       tab.setAttribute('aria-selected', 'true');
  //       tab.setAttribute('tabindex', '0');
  //       const items = featuredProducts[tab.dataset.category] || [];
  //       productGrid.style.opacity = '0';
  //       setTimeout(() => {
  //         productGrid.innerHTML = items.map(productCard).join('');
  //         productGrid.style.transition = 'opacity 0.25s ease';
  //         productGrid.style.opacity = '1';
  //       }, 120);
  //     }

  //     tabs.forEach((tab, i) => {
  //       tab.addEventListener('click', () => activateTab(tab));
  //       tab.addEventListener('keydown', (e) => {
  //         if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
  //           e.preventDefault();
  //           const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
  //           next.focus();
  //           activateTab(next);
  //         }
  //       });
  //     });

   document.addEventListener('DOMContentLoaded', function () {
    const featuredSection = document.querySelector('.aneezay-featured');
    if (!featuredSection) return;

    const dataEl = document.getElementById('featured-products-data');
    let featuredProducts = {};
    try {
      featuredProducts = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Featured products JSON failed to parse', e);
      return;
    }

    const SWATCHES = 'https://www.figma.com/api/mcp/asset/d0ff4968-e3d4-42aa-8047-f0bcfe382b42.svg';
    const productGrid = document.getElementById('featured-product-grid');
    const tabs = Array.from(featuredSection.querySelectorAll('.aneezay-featured__tabs button'));
    //add to cart from homepage 
    productGrid.addEventListener('click', function (e) {
  const btn = e.target.closest('.aneezay-button--product');
  if (!btn || btn.disabled) return;

  const variantId = btn.dataset.variantId;
  if (!variantId || variantId === 'null') return;

  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'ADDING...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((res) => {
      if (!res.ok) return res.json().then((err) => Promise.reject(err));
      return res.json();
    })
    .then(() => {
      btn.textContent = 'ADDED';
      
      return fetch('/cart.js');
    })
    .then((res) => res.json())
    .then((cart) => {
      const cartCounts = document.querySelectorAll('.aneezay-header__cart-count');
      cartCounts.forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1400);
     // window.location.href = '/cart';
    })
    .catch((err) => {
      console.error('Add to cart failed', err);
      btn.textContent = 'ERROR';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1400);
    });
});
    const productCard = (p) => `
  <article class="aneezay-product-card">
    <a href="${p.url}" class="aneezay-product-card__image">
      <img src="${p.image}" alt="${p.title}" loading="lazy">
    </a>
    <h3>${p.title.toUpperCase()}</h3>
    <div class="aneezay-product-card__price">
      <strong>${p.price}</strong>
      ${p.compare_at_price ? `<del>${p.compare_at_price}</del>` : ''}
    </div>
    <button
      class="aneezay-button aneezay-button--product"
      type="button"
      data-variant-id="${p.variant_id}"
      ${p.available ? '' : 'disabled'}
    >
      ${p.available ? 'ADD TO CART' : 'SOLD OUT'}
    </button>
  </article>
`;

    function activateTab(tab) {
      tabs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('tabindex', '-1');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');

      const items = featuredProducts[tab.dataset.category] || [];
      productGrid.style.opacity = '0';
      setTimeout(() => {
        productGrid.innerHTML = items.map(productCard).join('');
        productGrid.style.transition = 'opacity 0.25s ease';
        productGrid.style.opacity = '1';
      }, 120);
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          next.focus();
          activateTab(next);
        }
      });
    });

    // paint the default active tab on load, same as your static version did
    const initialTab = featuredSection.querySelector('.aneezay-featured__tabs [aria-selected="true"]') || tabs[0];
    if (initialTab) activateTab(initialTab);
  });

      // ---------- Carousel arrows: scroll their rail/grid ----------
      document.querySelectorAll('.aneezay-carousel-controls:not(.aneezay-carousel-controls--social):not(.aneezay-carousel-controls--best)').forEach((controls) => {
        const section = controls.closest('section');
        if (!section) return;
        const rail = section.querySelector('.aneezay-lifestyle__rail, .aneezay-product-grid, .aneezay-social__grid');
        if (!rail) return;
        const [prev, next] = controls.querySelectorAll('button');
        const step = () => Math.max(rail.clientWidth * 0.8, 260);
        prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
        next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      });

      // ---------- Carousel arrows: scroll their rail/grid ----------
      document.querySelectorAll('.aneezay-carousel-controls:not(.aneezay-carousel-controls--social):not(.aneezay-carousel-controls--best)').forEach((controls) => {
        const section = controls.closest('section');
        if (!section) return;
        const rail = section.querySelector('.aneezay-lifestyle__rail, .aneezay-product-grid, .aneezay-social__grid');
        if (!rail) return;
        const [prev, next] = controls.querySelectorAll('button');
        const step = () => Math.max(rail.clientWidth * 0.8, 260);
        prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
        next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      });
    
      /* ============================================================
         Mobile navigation drawer
         ============================================================ */
      (function () {
        var toggle = document.querySelector('.aneezay-header__toggle');
        var drawer = document.getElementById('aneezay-drawer');
        if (!toggle || !drawer) return;

        function setOpen(open) {
          drawer.hidden = !open;
          toggle.setAttribute('aria-expanded', String(open));
          document.body.style.overflow = open ? 'hidden' : '';
        }

        toggle.addEventListener('click', function () {
          setOpen(drawer.hidden);
        });

        drawer.addEventListener('click', function (e) {
          if (e.target.closest('[data-drawer-close]') || e.target.closest('a')) setOpen(false);
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !drawer.hidden) setOpen(false);
        });
      })();

      /* ============================================================
         Carousel — Owl/Slick-style behaviour without the jQuery
         responsive slides-per-view · arrows · dots · autoplay ·
         drag & swipe · keyboard · reduced-motion aware
         ============================================================ */
      (function () {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var DEFAULT_STEPS = [4, 3, 2, 1];

        /* data-per-view="4,3,2,2" => >=1200, >=900, >=600, below */
        function perView(width, steps) {
          if (width >= 1200) return steps[0];
          if (width >= 900) return steps[1];
          if (width >= 600) return steps[2];
          return steps[3];
        }

        function build(root) {
          var track = root.querySelector('[data-carousel-track]');
          if (!track) return;

          var slides = Array.prototype.slice.call(track.children);
          var section = root.closest('section') || document;
          var prev = section.querySelector('[data-carousel-prev]');
          var next = section.querySelector('[data-carousel-next]');
          var dotsBox = section.querySelector('[data-carousel-dots]');
          var delay = parseInt(root.dataset.autoplay || '0', 10);
          var steps = (root.dataset.perView || '')
            .split(',')
            .map(function (n) { return parseInt(n, 10); })
            .filter(function (n) { return n > 0; });
          if (steps.length !== 4) steps = DEFAULT_STEPS;

          var index = 0;
          var view = 1;
          var maxIndex = 0;
          var slideWidth = 0;
          var gap = 18;
          var timer = null;

          function measure() {
            gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
            view = Math.min(perView(root.clientWidth, steps), slides.length);
            slideWidth = (root.clientWidth - gap * (view - 1)) / view;
            slides.forEach(function (slide) {
              slide.style.width = slideWidth + 'px';
            });
            maxIndex = Math.max(0, slides.length - view);
            if (index > maxIndex) index = maxIndex;
          }

          function renderDots() {
            if (!dotsBox) return;
            dotsBox.innerHTML = '';
            for (var i = 0; i <= maxIndex; i++) {
              (function (i) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.setAttribute('role', 'tab');
                dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
                dot.addEventListener('click', function () {
                  goTo(i);
                  restart();
                });
                dotsBox.appendChild(dot);
              })(i);
            }
          }

          function paint(offset) {
            var x = -(index * (slideWidth + gap)) + (offset || 0);
            track.style.transform = 'translate3d(' + x + 'px,0,0)';

            slides.forEach(function (slide, i) {
              var visible = i >= index && i < index + view;
              slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
              slide.tabIndex = visible ? 0 : -1;
            });

            if (dotsBox) {
              Array.prototype.forEach.call(dotsBox.children, function (dot, i) {
                dot.classList.toggle('is-active', i === index);
                dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
              });
            }
          }

          function goTo(i) {
            index = Math.max(0, Math.min(i, maxIndex));
            paint();
          }

          /* wrap around, the way Owl's loop feels */
          function step(dir) {
            if (dir > 0) index = index >= maxIndex ? 0 : index + 1;
            else index = index <= 0 ? maxIndex : index - 1;
            paint();
          }

          function stop() {
            if (timer) { clearInterval(timer); timer = null; }
          }

          function start() {
            if (reduced || !delay || maxIndex === 0) return;
            stop();
            timer = setInterval(function () { step(1); }, delay);
          }

          function restart() { stop(); start(); }

          prev && prev.addEventListener('click', function () { step(-1); restart(); });
          next && next.addEventListener('click', function () { step(1); restart(); });

          root.addEventListener('mouseenter', stop);
          root.addEventListener('mouseleave', start);
          root.addEventListener('focusin', stop);
          root.addEventListener('focusout', start);

          document.addEventListener('visibilitychange', function () {
            document.hidden ? stop() : start();
          });

          section.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') { step(1); restart(); }
            if (e.key === 'ArrowLeft') { step(-1); restart(); }
          });

          /* pointer drag / touch swipe */
          var startX = 0, delta = 0, dragging = false;

          root.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            dragging = true;
            startX = e.clientX;
            delta = 0;
            root.classList.add('is-dragging');
            stop();
          });

          root.addEventListener('pointermove', function (e) {
            if (!dragging) return;
            delta = e.clientX - startX;
            paint(delta);
          });

          function endDrag() {
            if (!dragging) return;
            dragging = false;
            root.classList.remove('is-dragging');
            if (Math.abs(delta) > slideWidth * 0.18) step(delta < 0 ? 1 : -1);
            else paint();
            delta = 0;
            start();
          }

          root.addEventListener('pointerup', endDrag);
          root.addEventListener('pointercancel', endDrag);
          root.addEventListener('pointerleave', endDrag);

          root.addEventListener('click', function (e) {
            if (Math.abs(delta) > 6) e.preventDefault();
          }, true);

          function refresh() {
            measure();
            renderDots();
            paint();
          }

          var raf;
          window.addEventListener('resize', function () {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(refresh);
          });

          refresh();
          start();
        }

        document.querySelectorAll('[data-carousel]').forEach(build);
      })(); 


      //best seller js

  document.addEventListener('DOMContentLoaded', function () {
    var bestSellers = document.querySelector('.aneezay-best-sellers');
    if (!bestSellers) return;

    bestSellers.addEventListener('click', function (e) {
      var btn = e.target.closest('.aneezay-product-card__form .aneezay-button--product');
      if (!btn || btn.disabled) return;

      // Cancels the native form submit AND the wrapping <a>'s navigation
      e.preventDefault();
      e.stopPropagation();

      var form = btn.closest('form');
      if (!form) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { return Promise.reject(err); });
          return res.json();
        })
        .then(function () {
          btn.textContent = 'ADDED';
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // keep header badge + floating cart badge in sync
          document
            .querySelectorAll('.aneezay-header__cart-count, .aneezay-floating-cart__count')
            .forEach(function (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? '' : 'none';
            });

          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          btn.textContent = 'ERROR';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1400);
        });
    });
  });

    